import Layout from '@/components/feature/Layout';
import SEOMeta from '@/components/feature/SEOMeta';
import SchemaMarkup from '@/components/feature/SchemaMarkup';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/siteInfo';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: siteInfo.url,
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteInfo.url}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: siteInfo.url,
  description: siteInfo.description,
  email: siteInfo.email,
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '禁漫天堂是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '禁漫天堂是一个广受用户关注的成人漫画在线阅读平台，汇集了来自日本、韩国、中国以及欧美等地区的大量成人漫画作品。平台提供免费和会员两种使用模式，支持网页端和移动端访问。',
      },
    },
    {
      '@type': 'Question',
      name: '禁漫天堂的最新入口地址是什么？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '禁漫天堂的入口地址可能会因网络环境变化而调整。建议收藏本站的"最新入口地址"页面，我们会持续更新当前可用的域名和备用访问链接。',
      },
    },
    {
      '@type': 'Question',
      name: '禁漫天堂是否需要注册才能使用？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '禁漫天堂提供免费浏览模式，游客可以直接访问和阅读部分内容。但注册账号后可以享受更多功能，包括收藏漫画、参与评论、获得每日免费阅读额度等。',
      },
    },
  ],
};

export default function Home() {
  return (
    <Layout>
      <SEOMeta
        title={`${siteInfo.name} – ${siteInfo.tagline}`}
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl={siteInfo.url}
      />
      <SchemaMarkup schema={homepageSchema} />
      <SchemaMarkup schema={orgSchema} />
      <SchemaMarkup schema={faqSchema} />

      <HeroSection />
      <CategoryGrid />
      <FeaturedArticles />
      <FAQSection />
      <CTASection />
    </Layout>
  );
}